import PubSub from "underpub-js";
import Slick from "slick-carousel";
import Equalizer from "../../../../scripts/classes/Equalizer";

var ListingThreeUpNewsSlider = function(options) {

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

ListingThreeUpNewsSlider.prototype.init = function() {

	var self = this;

	this.options.$el.find('.news-type-slider-wrapper').each(function() {

		var $self = $(this);

		// sliders
		var $cardSlider = $(this).find('.card-slider');

		// initialize card slider
		$cardSlider.slick({
			arrows: false,
			fade: false,
			speed: 750,
			swipeToSlide: true,
			infinite: false,
			variableWidth: true,

			responsive: [
			
				{
					breakpoint: 768,
					settings: {
						centerMode: true,
						centerPadding: '0px',
						variableWidth: false,
						slidesToShow: 1,
					}
				},

			],

		});

		// previous/next buttons
		$(this).find('.slider-navigation .previous-button').on('click', function() {
			$cardSlider.slick('slickPrev');
		});

		$(this).find('.slider-navigation .next-button').on('click', function() {
			$cardSlider.slick('slickNext');
		});

		$cardSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		
			var slideNumber = nextSlide + 1;

			$self.find('.slide-number').removeClass('active');

			$self.find('.slide-number[data-slide-number="' + slideNumber + '"]').addClass('active');

		});

		// set up equalizer to set height of slide counter container because children are position: absolute
		var slideCounterEq = new Equalizer( $self.find('.slide-counter, .slide-counter .slide-number') );

		slideCounterEq.equalizeHeights();

		PubSub.subscribe("resized", function(){
			slideCounterEq.equalizeHeights();
		});

	});

	// cateogory links
	this.options.$el.find('.top-links .news-type-selector').on('click', function() {

		var newsTypeId = $(this).data('newsType');
		var $newsTypeSliderWrapper = $('.news-type-slider-wrapper[data-news-type="' + newsTypeId + '"]');

		self.options.$el.find('.news-type-slider-wrapper').removeClass('active');
		$newsTypeSliderWrapper.addClass('active');

		self.options.$el.find('.top-links .news-type-selector').removeClass('active');
		$(this).addClass('active');

	});

	// equalize the heights of our sliders so the page doesnt jump when we switch between them
	this.sliderEq = new Equalizer( self.options.$el.find('.news-type-slider-wrapper .card-slider') );

	this.sliderEq.equalizeHeights();

	PubSub.subscribe("resized", function(){
		self.sliderEq.equalizeHeights();
	});

};




export default ListingThreeUpNewsSlider;
